// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"APISalesCommissionPage_inputContainer__29o1b","headerActions":"APISalesCommissionPage_headerActions__1V-Hh"};